import { render, staticRenderFns } from "./FinalExamStatistics.vue?vue&type=template&id=74c44077"
import script from "./FinalExamStatistics.vue?vue&type=script&lang=js"
export * from "./FinalExamStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports